// extracted by mini-css-extract-plugin
export default {"vehicleFuelEfficiencyPanel":"VehicleFuelEfficiencyPanel_vehicleFuelEfficiencyPanel__+EvKf"};